"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerCreditDataPaymentInsuranceToJSON = exports.CustomerCreditDataPaymentInsuranceFromJSONTyped = exports.CustomerCreditDataPaymentInsuranceFromJSON = void 0;
function CustomerCreditDataPaymentInsuranceFromJSON(json) {
    return CustomerCreditDataPaymentInsuranceFromJSONTyped(json, false);
}
exports.CustomerCreditDataPaymentInsuranceFromJSON = CustomerCreditDataPaymentInsuranceFromJSON;
function CustomerCreditDataPaymentInsuranceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': json['enabled'],
        'age': json['age'],
    };
}
exports.CustomerCreditDataPaymentInsuranceFromJSONTyped = CustomerCreditDataPaymentInsuranceFromJSONTyped;
function CustomerCreditDataPaymentInsuranceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enabled': value.enabled,
        'age': value.age,
    };
}
exports.CustomerCreditDataPaymentInsuranceToJSON = CustomerCreditDataPaymentInsuranceToJSON;
//# sourceMappingURL=CustomerCreditDataPaymentInsurance.js.map